"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetYourPasswordForm = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var formik_1 = require("formik");
var enums_1 = require("../../shared/enums");
var il_box_common_1 = require("../il-box/il-box.common");
var il_button_common_1 = require("../il-button/il-button.common");
var il_form_label_common_1 = require("../il-form-label/il-form-label.common");
var il_password_field_1 = require("../il-password-field/il-password-field");
var reset_your_password_validation_1 = require("./reset-your-password.validation");
var ResetYourPasswordForm = function (props) {
    var formik = (0, formik_1.useFormik)({
        initialValues: {
            password: '',
            confirmPassword: '',
        },
        validationSchema: reset_your_password_validation_1.ResetPasswordFormValidation,
        onSubmit: function (formValues) {
            props.onSubmit(formValues);
        },
    });
    var values = formik.values, handleChange = formik.handleChange, errors = formik.errors, isValid = formik.isValid, dirty = formik.dirty, handleSubmit = formik.handleSubmit;
    return (react_1.default.createElement(il_box_common_1.ILFormBox, { sx: __assign(__assign({}, il_box_common_1.ILFormBoxArgs.sx), { maxWidth: 374 }) },
        react_1.default.createElement(material_1.Typography, { sx: {
                display: 'flex',
                justifyContent: 'center',
                textAlign: 'center',
            }, color: "text.primary", variant: enums_1.TypographyVariantEnum.H2 }, "Reset Your Password"),
        react_1.default.createElement(material_1.Typography, { sx: {
                display: 'flex',
                justifyContent: 'center',
                textAlign: 'center',
                py: 1,
                fontSize: 'button.fontSize',
                lineHeight: 1.62,
                fontWeight: 'normal',
                textTransform: 'unset',
            }, color: "text.secondary", variant: enums_1.TypographyVariantEnum.H3 }, "Your password must contain between 8 and 64 characters. Spaces are not allowed."),
        react_1.default.createElement("form", { onSubmit: handleSubmit },
            react_1.default.createElement(il_box_common_1.ILFormItemBox, { sx: __assign(__assign({}, il_box_common_1.ILFormItemBoxArgs.sx), { marginBottom: '0.5rem', gap: 1, mt: 0 }) },
                react_1.default.createElement(il_form_label_common_1.BoldFormLabel, null, "New Password"),
                react_1.default.createElement(il_password_field_1.ILPasswordField, { id: 'password', value: values.password, placeholder: "New Password", onChange: handleChange, error: Boolean(errors.password), helperText: errors.password })),
            react_1.default.createElement(il_box_common_1.ILFormItemBox, { sx: __assign(__assign({}, il_box_common_1.ILFormItemBoxArgs.sx), { marginBottom: '0.5rem', gap: 1, mt: 0 }) },
                react_1.default.createElement(il_form_label_common_1.BoldFormLabel, null, "Confirm New Password"),
                react_1.default.createElement(il_password_field_1.ILPasswordField, { id: 'confirmPassword', value: values.confirmPassword, placeholder: "Confirm New Password", onChange: handleChange, error: Boolean(errors.confirmPassword), helperText: errors.confirmPassword })),
            react_1.default.createElement(material_1.Box, { sx: {
                    justifyContent: 'center',
                    textAlign: 'center',
                    px: { md: 3, sm: 2, xs: 1 },
                } },
                react_1.default.createElement(il_button_common_1.ContainedButton, { sx: __assign(__assign({}, il_button_common_1.ContainedButtonArgs.sx), { width: '100%', height: 48, fontSize: 'h5.fontSize', mt: '1.5rem', mb: '1rem' }), type: enums_1.ButtonTypeEnum.SUBMIT, disabled: !(isValid && dirty) }, "Reset")))));
};
exports.ResetYourPasswordForm = ResetYourPasswordForm;
